import { QueryRenderer } from "components/clients/show-client/community-comparison/query-renderer";
import { ContentHeader, Stage } from "components/layout";
import { InlineBanner } from "components/ui/inline-banner";
import { useGetRecentConversationFeedForUserQuery } from "generated/graphql";
import React from "react";
import { Link, useParams } from "react-router-dom";
import { useFeature, useRegionId } from "store/selectors/hooks";
import { usePhoneLines } from "store/selectors/telecom";
import { ConversationFeed } from "./conversation-feed";

interface MessagingDashboardProps {}

export const MessagingDashboard: React.FC<MessagingDashboardProps> = props => {
    const { threadId } = useParams<{ threadId: string }>();
    const smsEnabled = useFeature("sms");
    const mailboxSyncEnabled = useFeature("mailboxSync");
    const phoneLines = usePhoneLines();

    if (!smsEnabled && !mailboxSyncEnabled) {
        return null;
    }

    const hasSmsConfigured = smsEnabled && phoneLines.length > 0;
    const showFeed = hasSmsConfigured || mailboxSyncEnabled;

    return (
        <Stage>
            <div className="flex flex-col gap-4 p-4">
                <ContentHeader>Latest conversations</ContentHeader>
                {smsEnabled && phoneLines.length === 0 ? (
                    <InlineBanner type="info">
                        To send and receive SMS messages, configure a personal phone line
                        in your{" "}
                        <Link to="/settings/account/phone">SMS &amp; Voice settings</Link>
                        .
                    </InlineBanner>
                ) : null}
                {showFeed ? <RecentConversationsFeed initialThreadId={threadId} /> : null}
            </div>
        </Stage>
    );
};

interface RecentConversationsFeedProps {
    initialThreadId: string | null;
}

const RecentConversationsFeed: React.FC<RecentConversationsFeedProps> = props => {
    const { initialThreadId } = props;
    const regionId = useRegionId();

    const query = useGetRecentConversationFeedForUserQuery({ regionId });

    return (
        <QueryRenderer
            query={query}
            name="RecentConversationsFeed.getRecentConversationFeedForUser">
            {data => {
                return (
                    <>
                        <ConversationFeed
                            feed={data?.getRecentConversationFeedForUser}
                            initialThreadId={initialThreadId}
                        />
                    </>
                );
            }}
        </QueryRenderer>
    );
};
